module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.value.length) ? _c('table', {
    staticClass: "table table-hover"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.value), function(file, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-xs green",
      attrs: {
        "type": "button",
        "href": _vm.url + '/form/download/file/' + _vm.field.name.split('-')[1] + '_' + file.file + '?token=' + _vm.token,
        "target": "_blank"
      }
    }, [_c('i', {
      staticClass: "fa fa-download",
      attrs: {
        "aria-hidden": "true"
      }
    })]), _vm._v(" "), (!_vm.locked) ? _c('button', {
      staticClass: "btn btn-xs green",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.removeFile(file)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()])])
  }), 0)]) : _vm._e(), _vm._v(" "), (!_vm.locked) ? _c('vue-upload-component', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.field.multiple || _vm.value.length === 0),
      expression: "field.multiple || value.length === 0"
    }],
    ref: "fileUploadRef",
    attrs: {
      "multiple": _vm.field.multiple,
      "input-id": 'f-' + _vm.field.name
    },
    on: {
      "input-file": _vm.inputFile,
      "input-filter": _vm.inputFilter
    },
    model: {
      value: (_vm.uploadedFiles),
      callback: function($$v) {
        _vm.uploadedFiles = $$v
      },
      expression: "uploadedFiles"
    }
  }, [_c('a', {
    staticClass: "btn green",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add File")])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-571a3654","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/FileRender.vue
// module id = 1645
// module chunks = 1